import logo from './logo.svg';
import Funnel from './components/Funnel';

import './App.css';
import { root } from 'postcss';


function App() {
  return (
    <div className="App">
      <Funnel 
        frage = "Test Frage Lorem Ipsum?" 
        needCard = {true}
        anzahlCards = {5}
      
      ></Funnel>
    </div>
  );
  root.render()
}

export default App;
